export const TYPE_TEST = 'TEST';
export const TYPE_TEXTBOOK = 'TEXT';

export const PERSIAN_TYPE_TEST = 'تست';
export const PERSIAN_TYPE_TEXTBOOK = 'مطالعه از درسنامه';

/**
 * @return {string}
 */
export function getTypeText(type) {
  switch (type) {
    case TYPE_TEST:
      return PERSIAN_TYPE_TEST;
    case TYPE_TEXTBOOK:
      return PERSIAN_TYPE_TEXTBOOK;
    default:
      return '';
  }
}
